/**
 * Helpers for calling shipping-services REST endpoints.
 *
 * The base URL is driven by VITE_API_BASE_URL and includes the `/shipping`
 * routing prefix. See `.env`.
 */

const BASE = (import.meta.env.VITE_API_BASE_URL || 'http://localhost:8010/shipping').replace(/\/+$/, '');

/** Build a full REST URL for a shipping-service endpoint. */
export function shippingApiUrl(path: string): string {
  const normalized = path.startsWith('/') ? path : `/${path}`;
  return `${BASE}${normalized}`;
}
